const FILE_DOWNLOAD_SUCCESS = 'FILE_DOWNLOAD_SUCCESS';
const FILE_DOWNLOAD_FAILURE = 'FILE_DOWNLOAD_FAILURE';
const FILE_DOWNLOAD_INIT = 'FILE_DOWNLOAD_INIT';
export { FILE_DOWNLOAD_SUCCESS, FILE_DOWNLOAD_FAILURE, FILE_DOWNLOAD_INIT };
